import React from 'react'

function DecisionMakingRules() {
  return (
    <div>DecisionMakingRules</div>
  )
}

export default DecisionMakingRules